import _classCallCheck from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Uniform, Vector2 } from "three";
import { BlendFunction } from "./blending/BlendFunction.js";
import { Effect } from "./Effect.js";
var fragment = "uniform float count;\r\n\r\nvoid mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {\r\n\r\n\tvec2 sl = vec2(sin(uv.y * count), cos(uv.y * count));\r\n\tvec3 scanlines = vec3(sl.x, sl.y, sl.x);\r\n\r\n\toutputColor = vec4(scanlines, inputColor.a);\r\n\r\n}\r\n";
/**
 * A scanline effect.
 */

export var ScanlineEffect =
/*#__PURE__*/
function (_Effect) {
  _inherits(ScanlineEffect, _Effect);

  /**
   * Constructs a new scanline effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.OVERLAY] - The blend function of this effect.
   * @param {Number} [options.density=1.25] - The scanline density.
   */
  function ScanlineEffect() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ScanlineEffect);

    var settings = Object.assign({
      blendFunction: BlendFunction.OVERLAY,
      density: 1.25
    }, options);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScanlineEffect).call(this, "ScanlineEffect", fragment, {
      blendFunction: settings.blendFunction,
      uniforms: new Map([["count", new Uniform(0.0)]])
    }));
    /**
     * The original resolution.
     *
     * @type {Vector2}
     * @private
     */

    _this.resolution = new Vector2();
    /**
     * The amount of scanlines, relative to the screen height.
     *
     * @type {Number}
     * @private
     */

    _this.density = settings.density;
    return _this;
  }
  /**
   * Returns the current scanline density.
   *
   * @return {Number} The scanline density.
   */


  _createClass(ScanlineEffect, [{
    key: "getDensity",
    value: function getDensity() {
      return this.density;
    }
    /**
     * Sets the scanline density.
     *
     * @param {Number} density - The new scanline density.
     */

  }, {
    key: "setDensity",
    value: function setDensity(density) {
      this.density = density;
      this.setSize(this.resolution.x, this.resolution.y);
    }
    /**
     * Updates the size of this pass.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */

  }, {
    key: "setSize",
    value: function setSize(width, height) {
      this.resolution.set(width, height);
      this.uniforms.get("count").value = Math.round(height * this.density);
    }
  }]);

  return ScanlineEffect;
}(Effect);